var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('label',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('label',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-226c6802","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/scanCheckout/child/CheckoutDesc.vue
// module id = null
// module chunks = 